import _classCallCheck from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import * as PropTypes from 'prop-types';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import omit from 'lodash/omit';
import set from 'lodash/set';
import ValidatedQuickForm from './ValidatedQuickForm';

var Auto = function Auto(parent) {
  var _ =
  /*#__PURE__*/
  function (_parent) {
    _inherits(_, _parent);

    function _() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, _);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(_)).call.apply(_getPrototypeOf2, [this].concat(args))); // @ts-ignore

      _this.state = Object.assign(Object.assign({}, _this.state), {
        model: _this.props.model,
        modelSync: _this.props.model
      });
      return _this;
    }

    _createClass(_, [{
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(_ref) {
        var model = _ref.model;

        // @ts-ignore
        _get(_getPrototypeOf(_.prototype), "componentWillReceiveProps", this).apply(this, arguments);

        if (!isEqual(this.props.model, model)) {
          this.setState(function () {
            return {
              model: model,
              modelSync: model
            };
          });
        }
      }
    }, {
      key: "getNativeFormProps",
      value: function getNativeFormProps() {
        return omit(_get(_getPrototypeOf(_.prototype), "getNativeFormProps", this).call(this), ['onChangeModel']);
      }
    }, {
      key: "getModel",
      value: function getModel(mode) {
        return mode === 'form' ? this.state.modelSync : this.state.model;
      }
    }, {
      key: "onChange",
      value: function onChange(key, value) {
        var _this2 = this;

        var updateState = function updateState(state) {
          return {
            modelSync: set(cloneDeep(state.modelSync), key, value)
          };
        };

        var updateModel = function updateModel(state) {
          if (_this2.props.onChangeModel) {
            _this2.props.onChangeModel(state.modelSync);
          }

          return {
            model: state.modelSync
          };
        }; // Before componentDidMount, every call to onChange should call BaseForm#onChange synchronously


        if (this.state.changed === null) {
          this.setState(updateState);

          _get(_getPrototypeOf(_.prototype), "onChange", this).call(this, key, value);

          this.setState(updateModel);
        } else {
          this.setState(updateState, function () {
            _get(_getPrototypeOf(_.prototype), "onChange", _this2).call(_this2, key, value);

            _this2.setState(updateModel);
          });
        }
      }
    }, {
      key: "__reset",
      value: function __reset(state) {
        return Object.assign(Object.assign({}, _get(_getPrototypeOf(_.prototype), "__reset", this).call(this, state)), {
          model: this.props.model,
          modelSync: this.props.model
        });
      }
    }, {
      key: "onValidate",
      value: function onValidate() {
        // @ts-ignore
        return this.onValidateModel(this.getChildContextModel());
      }
    }]);

    return _;
  }(parent);

  _.Auto = Auto;
  _.displayName = "Auto".concat(parent.displayName);
  _.propTypes = Object.assign(Object.assign({}, parent.propTypes), {
    onChangeModel: PropTypes.func
  });
  return _;
};

export default Auto(ValidatedQuickForm);